var _find = require('lodash/collection/find');
var _indexOf = require('lodash/array/indexOf');
var moment = require('moment');

var DAYSTART = 9;
var DAYEND = 18;
var BUFFER_BEFORE = 0;
var BUFFER_AFTER = 0;
var BUFFER_FROM_NOW = 2;
var FULL = 0;
var AVAILABLE = 1;
var UNAVAILABLE = 2;

var booking = {};

/*
** Rules for slot availability:
** 1. Bookings can not be made less than 1 hour before they would start
** 2. Bookings must have 1 hour clear on either side to allow for travel time, UNLESS:
**    a) Booking starts at DAYSTART
**    b) Booking ends at DAYEND
** SUMMARY:
** All slots starting 1 hour before the start time (unless start time = DAYSTART), through the length of the job and ending 1 hour after the job end (unless job end = DAYEND)
*/

booking.checkSlotAvailability = function(slot, manHours, date, availability) {
  var dateAvailability = _find(availability, 'Date', date);
  manHours = Number(manHours);

  //If we don't have any availability info for that date, return 0
  if (!dateAvailability) return FULL;
  var availableSlots = dateAvailability.HoursAvailable;

  //Lets check if the date is today, if it is and the slot is before the current hour + 1 then mark it as unavailable (return 0)
  var now = moment();
  if (now.isSame(date, 'day')) {
    var currentHourPlusOne = now.hour() + BUFFER_FROM_NOW;
    if (currentHourPlusOne >= slot) return UNAVAILABLE;
  }

  //If the requested time is outside of the working day return 0
  if (slot < DAYSTART || slot > DAYEND - 1) return FULL;

  var bookingStart = slot === DAYSTART ? DAYSTART : slot - BUFFER_BEFORE; //1 hour before the chosen time needs to be available for travel (unless it's the first slot of the day)
  var bookingEnd = slot + manHours + BUFFER_AFTER; //1 hour after the chosen time + job length needs to be available for travel

  var isSlotAvailable = manHours > 1 ? booking.checkSlotAvailability(slot, 1, date, availability) : false;
  for (var i = bookingStart;i<bookingEnd;i++) {
    var isNotAvailable = availableSlots.indexOf(i) === -1 && i !== DAYEND || availableSlots.indexOf(i) === -1 && i !== DAYEND - 1; //Check if the slot is not available
    if (isNotAvailable && isSlotAvailable) return UNAVAILABLE; //The slot is available if the booking was shorter, but the booking can't start in it, given it's length
    if (isNotAvailable) return FULL;
  }

  return AVAILABLE; //If we get here, then the slot is available
};

booking.availability = {};

booking.updateAvailabilityObject = function(teamId, availability) {
  teamId = teamId + '';
  if (!booking.availability[teamId]) {
    booking.availability[teamId] = availability;
  } else {
    booking.availability[teamId] = [];
    $.each(availability, function() {
      var itemDate = this.Date;
      var existingItemIndex = _indexOf(booking.availability[teamId], _find(booking.availability[teamId],'Date',itemDate));
      if (existingItemIndex !== -1) {
        booking.availability[teamId][existingItemIndex] = this;
      } else {
        booking.availability[teamId].push(this);
      }
    });
  }
};

booking.checkLocalAvailability = function(startDate, endDate, teamId) {
  teamId = teamId + '';
  if (!booking.availability[teamId]) return false;
  var startMoment = moment(startDate);
  var endMoment = moment(endDate);
  var availability = [];
  for (var date = startMoment; date.valueOf() <= endMoment.valueOf(); date.add(1, 'days')) {
    if (date.day() === 0) continue;
    var dateAvailability = _find(booking.availability[teamId],'Date',date.format('YYYY-MM-DD'));
    if (dateAvailability) {
      availability.push(dateAvailability);
    } else {
      return false;
    }
  }
  return availability;
};

booking.getAvailability = function(startDate, endDate, teamId, availabilityUrl) {
  var localAvailability = booking.checkLocalAvailability(startDate, endDate, teamId);
  if (localAvailability) {
    return {
      done: function(callback) {
        if (typeof callback === 'function') callback(localAvailability);
      },
      fail: function() {
        return false;
      },
      always: function() {
        return false;
      }
    };
  } else {
    var remoteAvailability = $.ajax({
      type: 'GET',
      contentType: 'application/json',
      url: availabilityUrl,
      data: {
        StartDate: startDate,
        EndDate: endDate
      }
    });
    remoteAvailability.done(function(response) {
      if (response.Value && response.Value.length) {
        $.each(response.Value, function() {
          booking.updateAvailabilityObject(this.SaintId, this.Availability);
        });
      }
    });
    return remoteAvailability;
  }
};

booking.DAYSTART = DAYSTART;
booking.DAYEND = DAYEND;

module.exports = booking;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/bookingLogic.js
// module id = 264
// module chunks = 0